/******************************************************************************
 * Copyright (c) 2016 - 2021.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2021-12-09                                                        *
 ******************************************************************************/

import { ref, reactive } from 'vue'

export default function () {
    function priceStoreToPricesText(price_store){
        let value_pairs = [];
        Object.keys(price_store).forEach((key)=>{
            value_pairs.push(`"${key}"="${price_store[key]}"`);
        });
        return value_pairs.join(' ');
    }
    return {
        priceStoreToPricesText
    }
}
